import * as React from 'react';
import { SVGUniqueID } from 'react-svg-unique-id';

import { SVGComponentProps } from '../type';

const InfoCircleIcon: React.FC<SVGComponentProps> = ({
  width = 16,
  height = 16,
  fill = '#B45309'
}) => (
  <SVGUniqueID>
    <svg
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.003 15.167A7.173 7.173 0 0 1 .836 8 7.173 7.173 0 0 1 8.003.833 7.173 7.173 0 0 1 15.169 8a7.173 7.173 0 0 1-7.166 7.167Zm0-13.334A6.174 6.174 0 0 0 1.836 8c0 3.4 2.767 6.167 6.167 6.167S14.169 11.4 14.169 8s-2.766-6.167-6.166-6.167Z"
        fill={fill}
      />
      <path
        d="M8 9.167a.504.504 0 0 1-.5-.5V5.333c0-.273.227-.5.5-.5s.5.227.5.5v3.334c0 .273-.227.5-.5.5ZM8.003 11.333a.664.664 0 0 1-.254-.053.77.77 0 0 1-.22-.14.688.688 0 0 1-.14-.22.664.664 0 0 1-.053-.253c0-.087.02-.174.053-.254a.77.77 0 0 1 .14-.22.771.771 0 0 1 .22-.14.667.667 0 0 1 .507 0c.08.034.153.08.22.14a.77.77 0 0 1 .14.22c.033.08.053.167.053.254 0 .086-.02.173-.053.253a.688.688 0 0 1-.14.22.77.77 0 0 1-.22.14.664.664 0 0 1-.253.053Z"
        fill={fill}
      />
    </svg>
  </SVGUniqueID>
);

InfoCircleIcon.defaultProps = {
  width: 16,
  height: 16,
  fill: '#B45309'
};

export { InfoCircleIcon };
